<div *ngIf="isMobile" class="not_support">
    <h1 class="main_sign">?</h1>
    <img src="../assets/smart_owl.png" alt="owl mobile" class="main_icon" />
    <h4>Busted!</h4>
    <span>Your screen is too small for all the big ideas!</span>
    <span>A mobile version of MemOwl is coming soon.</span>
    <span>In the meantime, please open the app on a desktop browser.</span>
    <span class="supported">Supported browsers:</span>
    <div class="icons">
        <img src="../assets/chrome.png" alt="chrome" />
        <img src="../assets/opera.png" alt="opera" />
        <img src="../assets/edge 1.png" alt="edge" />
        <img src="../assets/vivaldi.png" alt="vivaldi" />
    </div>
</div>

<ng-container *ngIf="coords.isManager && stageManagerComponent && !isMobile">
    <ng-container *ngComponentOutlet="stageManagerComponent"></ng-container>
</ng-container>



<ng-container *ngIf="coords.isLicenseManager && stageLicenseComponent && !isMobile">
    <ng-container *ngComponentOutlet="stageLicenseComponent"></ng-container>
</ng-container>

<ng-container *ngIf="sectionFooterComponent && !isMobile">
    <div class="sticky-footer">
        <ng-container *ngComponentOutlet="sectionFooterComponent"></ng-container>
    </div>
</ng-container>

<!-- <app-section-footer></app-section-footer> -->

<div *ngIf="coords.display$.isExternalLogin && !isMobile" class="external-login">
    {{ coords.text('LoginProcessingInProgress') }}
</div>
